import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import Select from '../common/AppSelect';
import { LookupCursadasAlumnos } from '../Cursadas/LookupCursadasAlumnos';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
  classifyInscripcionesError,
  mapCarrerasInscripcionToSelectOptions,
  toInscripcionCursadaMultiplePayload,
  validateInscripcionCursadaMultipleForm
} from '../../services/inscripciones/inscripcionesDto';
import { getPeriodoCursadaLabel } from '../../services/periodos/periodosDto';
import { MdPageErrorMessage } from '../common/mdPageErrorMessage';

export class AddInscripcionCursadaAlumnos extends Component {
  static displayName = AddInscripcionCursadaAlumnos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showCursada: false,
      tagDataAlumno: [{ value: '', label: '' }],
      tagDataCursada: [{ id: '', text: '', materiaCarreraCod3: '' }],
      alumno: 0,
      carreraCursada: -1,
      ignorarCorrelatividad: false,
    };
  }

  handleConfirmButton = () => {
    if (!validateInscripcionCursadaMultipleForm({
      alumnoId: this.state.alumno,
      cursadaCount: this.state.tagDataCursada.slice(1).length
    })) {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
    } else {
      this.saveStudent();
    }
  };

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('InscribirCursada');
    if (canAccess) {
      this.populateData();
    }
  }

  handleChangeAlumno = (e) => {
    const carreraProperties = e.value.toString().split('-');
    this.setState({
      alumno: parseInt(carreraProperties[1], 10),
      carreraCursada: parseInt(carreraProperties[0], 10),
      tagDataCursada: [{ id: '', text: '', materiaCarreraCod3: '' }],
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleDeleteCursada = (id) => {
    this.setState({
      tagDataCursada: this.state.tagDataCursada.filter((tag) => tag.id !== id),
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleShowCursadaLookup = () => {
    this.setState({ showCursada: true });
  };

  handleHideLookupCursada = () => {
    this.setState({ showCursada: false });
  };

  handleSelectCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    const tag = {
      id: carreraProperties[0],
      text: carreraProperties[1].trim() + ' - ' + getPeriodoCursadaLabel(carreraProperties[2]) + ' - ' + carreraProperties[3].trim(),
      materiaCarreraCod3: carreraProperties[4].trim(),
    };
    const tagData = this.state.tagDataCursada;
    const existe = tagData.filter((x) => x.id === carreraProperties[0]);
    const materiaDuplicada = tagData.some((x) => x.materiaCarreraCod3 === tag.materiaCarreraCod3);
    if (existe.length === 0 && !materiaDuplicada) {
      tagData.push(tag);
      this.setState({
        showCursada: false,
        tagDataCursada: tagData,
        showErrorMessage: false,
        errorMessage: '',
      });
    } else if (materiaDuplicada) {
      this.setState({
        showCursada: false,
        showErrorMessage: true,
        errorMessage: 'Ya existe una inscripción para la misma materia.',
      });
    } else {
      this.setState({ showCursada: false });
    }
  };

  renderCursadaTags() {
    const tagData = this.state.tagDataCursada.slice(1);
    if (!tagData.length) {
      return null;
    }
    return (
      <ul className="md-page__tag-list">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-page__tag">
            <span>{tag.text}</span>
            {!this.state.loading ? (
              <button
                type="button"
                className="md-page__tag-remove"
                aria-label={'Quitar cursada ' + tag.text}
                onClick={() => this.handleDeleteCursada(tag.id)}
              >
                ×
              </button>
            ) : null}
          </li>
        ))}
      </ul>
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-ica" />;
    }

    const { loading } = this.state;
    const canSelectCursada = !loading && this.state.carreraCursada !== -1;

    return (
      <div className="md-page md-add-ica">
        <Link className="md-page__back-link" to="/md-ica">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Inscripción a Cursada</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione la carrera y una o más cursadas para inscribirse.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <MdPageErrorMessage message={this.state.errorMessage} />
          ) : null}
          {this.state.errorMessage && !this.state.showErrorMessage ? (
            <MdPageErrorMessage message={this.state.errorMessage} />
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Carrera</span>
            <Select
              className="md-page__field-select"
              placeholder="Seleccionar la carrera"
              options={this.state.tagDataAlumno}
              disabled={loading}
              onChange={this.handleChangeAlumno}
            />
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Cursadas</span>
            <div className="md-page__picker-block">
              {canSelectCursada ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                  Seleccionar la cursada
                </button>
              ) : (
                <p className="md-page__file-hint">Seleccione una carrera antes de elegir las cursadas.</p>
              )}
              {this.renderCursadaTags()}
            </div>
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showCursada ? (
          <LookupCursadasAlumnos
            alumnoCarreraCod={this.state.alumno}
            carreraCod={this.state.carreraCursada}
            selectItem={this.handleSelectCursadaItem}
            hideLookup={this.handleHideLookupCursada}
          />
        ) : null}
      </div>
    );
  }

  async populateData() {
    try {
      const returnModel = await inscripcionesService.listCarrerasInscripcionAlumno();
      this.setState({
        errorMessage: '',
        tagDataAlumno: mapCarrerasInscripcionToSelectOptions(returnModel),
      });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({ errorMessage: outcome.message });
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    const cursadas = this.state.tagDataCursada.slice(1).map((tag) => ({
      cursada: parseInt(tag.id, 10),
      materiaCarreraCod: tag.materiaCarreraCod3,
    }));
    try {
      await inscripcionesService.saveInscripcionesCursadaMultiple(toInscripcionCursadaMultiplePayload({
        alumnoxCarreraCod: this.state.alumno,
        ignorarCorrelatividad: this.state.ignorarCorrelatividad,
        cursadas,
      }));
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
